import { createAsyncThunk } from "@reduxjs/toolkit";
import giftService from "../../../api/services/gift";

export const createCompanyGiftingDetails = createAsyncThunk(
  "company/create-company-gifting-details",
  async (requestData) => {
    return await giftService.createCompanyGiftingDetails(requestData);
  }
);
